export default __webpack_public_path__ + "media/img/bgicon-40a8afd3ae58f7011aee4b8b55fcdf84.svg";